// extracted by mini-css-extract-plugin
module.exports = {"footer":"BlogFooter_footer__jiddt","inner":"BlogFooter_inner__1jXB2","links":"BlogFooter_links__11edw","copyright":"BlogFooter_copyright__1wbgh"};